{
  "name": "Weihnachtsquiz",
  "questions": [
    {
      "answers": [
        {
          "id": 174554,
          "text": " Sie ist dem Bischof Nikolaus von Myra nachempfunden.",
          "is_right": true
        },
        {
          "id": 174555,
          "text": "Sie stammt aus einer Marketingaktion von Coca-Cola.",
          "is_right": false
        },
        {
          "id": 174556,
          "text": "Sie ist einer Gestalt aus einem antiken Mythos nachempfunden.",
          "is_right": false
        },
        {
          "id": 174557,
          "text": "Sie stammt aus einem Märchen der Gebrüder Grimm.",
          "is_right": false
        }
      ],
      "tags": [
        {
          "id": 37181,
          "name": "Weihnachten"
        }
      ],
      "id": 37223,
      "text": "Worin liegt die Vorstellung vom Weihnachtsmann begründet?",
      "weblink": "https://de.wikipedia.org/wiki/Nikolaus_von_Myra",
      "is_poll_question": false,
      "explanation": "**Korrekte Antwort:**\n*  Er ist dem Bischof Nikolaus von Myra nachempfunden.\n\n**Weiterführende Informationen:**\n\nBischof Nikolaus von Myra lebte im 4. Jahrhundert und pflegte es, großzügige Geschenke an die Armen zu verteilen. Der Einlegebrauch, das Füllen der Schuhe in der Nacht vom 5. auf den 6. Dezember oder Ähnliches, basiert auf der Legende von den drei Jungfrauen, die nachts vom heiligen Nikolaus beschenkt wurden. Ursprünglich war der Nikolaustag auch der Tag der Weihnachtsbescherung. In einigen Ländern ist er dies auch heute noch. \n\nErst infolge der Ablehnung der Heiligenverehrung durch die Reformation wurde die Bescherung in vielen Ländern auf Weihnachten verlegt, und infolgedessen wurde Nikolaus als Gabenbringer mancherorts vom Christkind abgelöst.",
      "type": 2,
      "created_at": "2021-08-25T15:43:21.000Z",
      "created_by": "e2618e02-c548-4f70-a537-f982a6d09e84",
      "updated_at": "2022-10-06T14:31:28.000Z",
      "updated_by": "e2618e02-c548-4f70-a537-f982a6d09e84",
      "position": 1,
      "media": {
        "id": 8110,
        "uuid": "c092cca0-44a9-11eb-9f5f-7d575d25de6e",
        "file_ext": "jpeg",
        "url": "https://s3.eu-central-1.amazonaws.com/media.quizacademy.io/c092cca0-44a9-11eb-9f5f-7d575d25de6e.jpeg"
      },
      "num_answers": 4
    },
    {
      "answers": [
        {
          "id": 174545,
          "text": "Hyvää joulua",
          "is_right": true
        },
        {
          "id": 174546,
          "text": "¡Buon Natale!",
          "is_right": false
        },
        {
          "id": 174547,
          "text": "Merry Christmas",
          "is_right": false
        },
        {
          "id": 174548,
          "text": "Joyeux Noël",
          "is_right": false
        },
        {
          "id": 477237,
          "text": "¡Feliz Navidad!",
          "is_right": false
        }
      ],
      "tags": [
        {
          "id": 37181,
          "name": "Weihnachten"
        }
      ],
      "id": 37221,
      "text": "Wie wünscht man \"Frohe Weihnachten\" auf Finnisch?",
      "weblink": "https://www.kribbelbunt.de/artikel/news/frohe-weihnachten-in-verschiedenen-sprachen/",
      "is_poll_question": false,
      "explanation": "**Korrekte Antwort:**\n* Hyvää joulua\n\n**Weiterführende Informationen:**\n\nWisst Ihr, wie man Frohe Weihnachten in allen Sprachen der Welt wünscht? Das wäre mal eine interessante Idee, Freunde und Verwandte mit einem Frohe Weihnachten auf Französisch, Italienisch, Spanisch, Polnisch oder Ukrainisch zu überraschen! Oder spricht der ein oder andere eurer Nachbarn eine andere Sprache, feiert aber auch Weihnachten, genauso wie wir? Dann wäre es sicher toll, die Nachbarn in ihrer Muttersprache frohe Weihnachten zu wünschen!\n\n***Frohe Weihnachten*** heißt auf:\n\n**Afrikaans**: Geseënde Kersfees\n**Albanisch**: Gezur Krislinjden\n**Arabisch**: I'D Miilad Said\n**Argentinisch**: Feliz Navidad\n**Armenisch**: Shenoraavor Nor Dari yev Pari Gaghand\n**Portugiesisch (Brasilien)**: Boas Festas e Feliz Ano Novo\n**Bulgarisch**: Tchestita Koleda / Tchestito Rojdestvo Hristovo\n**Chinesisch (Cantonese)**: Gun Tso Sun Tan’Gung Haw Sun\n**Chinesisch (Mandarin)**: Kung His Hsin Nien bing Chu Shen Tan\n**Dänisch**: Glædelig Jul\n**Hebräisch**: Mo'adim Lesimkha\n**Hindi**: Shubh Naya Baras\n**Holländisch**: Vrolijk Kerstfeest en een Gelukkig Nieuwjaar / Zalig Kerstfeast\n**Englisch**: Merry Christmas\n**Eskimo (inupik)**: Jutdlime pivdluarit ukiortame pivdluaritlo\n**Esperanto**: Gajan Kristnaskon\n**Faeroese**: Gledhilig jol og eydnurikt nyggjar\n**Finnisch**: Hyvaa joulua\n**Französisch**: Joyeux Noel\n**Friesisch**: Noflike Krystdagen en in protte Lok en Seine yn it Nije Jier\n**Galician**: Bo Nada\n**Gaelic**: Nollaig chridheil agus Bliadhna mhath ùr\n**Griechisch**: Kala Christouyenna\n**Hebräisch**: Mo’adim Lesimkha. Chena tova\n**Hindi**: Shub Naya Baras\n**Ungarisch**: Kellemes Karacsonyi unnepeket\n**Isländisch**: Gledileg Jol\n**Indonesisch**: Selamat Hari Natal\n**Irisch**: Nollaig Shona Dhuit, or Nodlaig mhaith chugnat\n**Italienisch**: ¡Buon Natale!\n**Japanisch**: Shinnen omedeto. Kurisumasu Omedeto\n**Koreanisch**: Sung Tan Chuk Ha\n**Kolumbianisch**: Feliz Navidad y Próspero Año Nuevo\n**Katalanisch**: Bon Nadal i un Bon Any Nou\n**Korsianisch**: Pace e salute\n**Kroatisch**: Sretan Bozic\n**Lettisch**: Prieci’gus Ziemsve’tkus un Laimi’gu Jauno Gadu\n**Litauisch**: Linksmy Šv. Kalédy\n**Maltesisch**: LL Milied Lt-tajjeb\n**Norwegisch**: God Jul / Gledelig Jul\n**Papua New Guinea**: Bikpela hamamas blong dispela Krismas na Nupela yia i go long yu\n**Pennsylvania German:** En frehlicher Grischtdaag un en hallich Nei Yaahr\n**Philippinisch**: Maligayan Pasko!\n**Polnisch**: Wesolych Swiat Bozego Narodzenia or Boze Narodzenie\n**Portugiesisch**: Feliz Natal\n**Rumänisch**: Sarbatori vesele\n**Russisch**: S Rozhdestvom Christovim\n**Serbisch**: Hristos se rodi\n**Slowakisch**: Veselé Vianoce\n**Spanisch**: ¡Feliz Navidad!\n**Schwedisch**: God Jul and (Och) Ett Gott Nytt År\n**Tchechisch**: Prejeme Vam Vesele Vanoce a stastny Novy Rok\n**Thailändisch**: Suksan Wan Christmas\n**Türkisch**: Noeliniz Ve Yeni Yiliniz Kutlu Olsun\n**Ukrainisch**: Z Rizdvom Khrystovym\n**Ungarisch**: Kellemes karácsonyt és boldog Újévet\n**Vietnamesisch**: Chung Mung Giang Sinh",
      "source": "https://www.kribbelbunt.de/artikel/news/frohe-weihnachten-in-verschiedenen-sprachen/",
      "type": 2,
      "created_at": "2021-08-25T15:43:20.000Z",
      "created_by": "e2618e02-c548-4f70-a537-f982a6d09e84",
      "updated_at": "2022-10-06T15:29:40.000Z",
      "updated_by": "e2618e02-c548-4f70-a537-f982a6d09e84",
      "position": 2,
      "media": {
        "id": 8108,
        "uuid": "742f4de0-44a2-11eb-9f5f-7d575d25de6e",
        "file_ext": "jpeg",
        "url": "https://s3.eu-central-1.amazonaws.com/media.quizacademy.io/742f4de0-44a2-11eb-9f5f-7d575d25de6e.jpeg"
      },
      "num_answers": 5
    },
    {
      "answers": [
        {
          "id": 174541,
          "text": "Heilige Drei Könige",
          "is_right": true
        },
        {
          "id": 174542,
          "text": "Väterchen Frost",
          "is_right": false
        },
        {
          "id": 174543,
          "text": "Weihnachtsmann",
          "is_right": false
        },
        {
          "id": 174544,
          "text": "Christkind",
          "is_right": false
        }
      ],
      "tags": [
        {
          "id": 37181,
          "name": "Weihnachten"
        }
      ],
      "id": 37220,
      "text": "Wer bringt den Kindern in Spanien an Weihnachten Geschenke?",
      "weblink": "https://de.wikipedia.org/wiki/Heilige_Drei_K%C3%B6nige",
      "is_poll_question": false,
      "explanation": "**Korrekte Antwort:**\n* Heilige Drei Könige\n\n**Weiterführende Informationen:**\n\nAls Heilige Drei Könige oder Weise aus dem Morgenland bezeichnet die christliche Tradition die in der Weihnachtsgeschichte des Matthäusevangeliums (Mt 2 EU) erwähnten „Sterndeuter“, die durch den Stern von Betlehem zu Jesus geführt wurden.",
      "source": "https://de.wikipedia.org/wiki/Heilige_Drei_K%C3%B6nige",
      "type": 2,
      "created_at": "2021-08-25T15:43:20.000Z",
      "created_by": "e2618e02-c548-4f70-a537-f982a6d09e84",
      "updated_at": "2022-10-06T15:23:15.000Z",
      "updated_by": "e2618e02-c548-4f70-a537-f982a6d09e84",
      "position": 3,
      "media": {
        "id": 8107,
        "uuid": "705731e0-44a4-11eb-9f5f-7d575d25de6e",
        "file_ext": "jpeg",
        "url": "https://s3.eu-central-1.amazonaws.com/media.quizacademy.io/705731e0-44a4-11eb-9f5f-7d575d25de6e.jpeg"
      },
      "num_answers": 4
    },
    {
      "answers": [
        {
          "id": 174566,
          "text": "Ägypten.",
          "is_right": true
        },
        {
          "id": 174567,
          "text": "Schweden.",
          "is_right": false
        },
        {
          "id": 174568,
          "text": "Schweiz.",
          "is_right": false
        },
        {
          "id": 174569,
          "text": "Italien.",
          "is_right": false
        }
      ],
      "tags": [
        {
          "id": 37181,
          "name": "Weihnachten"
        }
      ],
      "id": 37226,
      "text": "In welchem Land wurde der Lebkuchen erfunden? Der Lebkuchen stammt ursprünglich aus ...",
      "weblink": "https://de.wikipedia.org/wiki/Lebkuchen#Geschichte",
      "is_poll_question": false,
      "explanation": "**Korrekte Antwort:**\n* Der Lebkuchen stammt ursprünglich aus Ägypten.\n\n**Weiterführende Informationen:**\n\nErste schriftliche Zeugnisse von kleinen gewürzten Honigkuchen entstanden um 350 v. Chr., doch bereits die alten Ägypter haben honiggesüßte Kuchen gekannt, wie man aus Grabbeigaben weiß. \n\nDie Römer kannten den panis mellitus: Honig wurde auf einen Kuchen gestrichen, dann mit dem Kuchen mitgebacken. Anders als heute wurde der Lebkuchen nicht nur zur Weihnachtszeit verzehrt, sondern auch zu Ostern oder anderen Zeiten. \n\nDie Lebkuchen waren ein Bestandteil der Fastenküche und wurden z. B. zu starkem Bier serviert.",
      "type": 2,
      "created_at": "2021-08-25T15:43:21.000Z",
      "created_by": "e2618e02-c548-4f70-a537-f982a6d09e84",
      "updated_at": "2022-10-07T08:17:18.000Z",
      "updated_by": "e2618e02-c548-4f70-a537-f982a6d09e84",
      "position": 4,
      "media": {
        "id": 8113,
        "uuid": "e0a9f760-44a5-11eb-9f5f-7d575d25de6e",
        "file_ext": "jpg",
        "url": "https://s3.eu-central-1.amazonaws.com/media.quizacademy.io/e0a9f760-44a5-11eb-9f5f-7d575d25de6e.jpg"
      },
      "num_answers": 4
    },
    {
      "answers": [
        {
          "id": 174570,
          "text": "Honig",
          "is_right": true
        },
        {
          "id": 174571,
          "text": "Hirschhornsalz",
          "is_right": true
        },
        {
          "id": 174572,
          "text": "Pottasche",
          "is_right": true
        },
        {
          "id": 174573,
          "text": "Marzipan",
          "is_right": false
        },
        {
          "id": 174574,
          "text": "Haselnüsse",
          "is_right": false
        }
      ],
      "tags": [
        {
          "id": 37181,
          "name": "Weihnachten"
        }
      ],
      "id": 37227,
      "text": "Welche der Zutaten gehören in einen Lebkuchen?",
      "weblink": "https://de.wikipedia.org/wiki/Lebkuchen",
      "is_poll_question": false,
      "explanation": "**Korrekte Antwort(en):**\n* Honig\n* Hirschhornsalz\n* Pottasche\n\n**Weiterführende Informationen:**\n\nLebkuchen ist ein süßes, kräftig gewürztes, haltbares Gebäck, das in vielfältigen Formen und Varianten vorkommt. \n\nIn vielen Kulturen ist er ein fester Bestandteil des Weihnachtsgebäcks, nur wenige Sorten werden insbesondere auf Jahrmärkten und Volksfesten ganzjährig angeboten. Die Bäcker zählen Lebkuchen zu den Dauerbackwaren.\n\nDie Lebkuchenherstellung hat eine lange Tradition und ist vielerorts Teil der lokalen Backkultur, wovon verschiedene geschützte Herkunftsbezeichnungen für regionale Lebkuchenspezialitäten zeugen wie beispielsweise Nürnberger Lebkuchen, Aachener Printen.",
      "type": 0,
      "created_at": "2021-08-25T15:43:21.000Z",
      "created_by": "e2618e02-c548-4f70-a537-f982a6d09e84",
      "updated_at": "2022-10-06T14:22:16.000Z",
      "updated_by": "e2618e02-c548-4f70-a537-f982a6d09e84",
      "position": 5,
      "media": {
        "id": 8114,
        "uuid": "6a01c130-44a3-11eb-9f5f-7d575d25de6e",
        "file_ext": "jpeg",
        "url": "https://s3.eu-central-1.amazonaws.com/media.quizacademy.io/6a01c130-44a3-11eb-9f5f-7d575d25de6e.jpeg"
      },
      "num_answers": 5
    }
  ],
  "selected_music": "Christmas"
}